<template>
  <div class="search-engine-top-response">
    <SearchSuggests :result="result?.suggest" @selectSuggest="$emit('selectSuggest', $event)" />
    <div class="search-engine-top-response-main">
      <div>
        <div v-if="isShowSections" class="search-engine-top-response__block">
          <h6 v-if="sectionsTitle" class="search-engine-top-response__title">
            {{ sectionsTitle }}
          </h6>

          <div class="search-engine-top-response__sections">
            <a
              v-for="section in getSections"
              :href="section.url"
              class="search-engine-top-response__section"
            >
              {{ section.name }}
            </a>
          </div>
        </div>
        <div v-if="isShowCollections" class="search-engine-top-response__block">
          <h6 v-if="collectionsTitle" class="search-engine-top-response__title">
            {{ collectionsTitle }}
          </h6>
          <div class="search-engine-top-response__sections">
            <a
              v-for="collection in result.collections"
              :href="collection.url"
              class="search-engine-top-response__section"
            >
              {{ collection.name }}
            </a>
          </div>
        </div>
      </div>
      <div v-if="isShowProducts" class="search-engine-top-response__block">
        <h6 v-if="itemsTitle" class="search-engine-top-response__title">
          {{ itemsTitle }}
        </h6>
        <div class="search-engine-top-response__products">
          <SearchProduct v-for="item in result.products.items" :key="getId(item)" :result="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchProduct from '@components/Search/SearchProduct.vue';
import SearchSuggests from '@components/Search/SearchSuggests.vue';

export default {
  name: 'SearchEngineTopResponse',
  components: {
    SearchSuggests,
    SearchProduct,
  },
  props: ['result'],
  computed: {
    getSections() {
      // return this.result?.sections?.slice(1);
      return this.result?.sections;
    },
    isShowProducts() {
      return !!this.result?.products?.items?.length;
    },
    isShowCollections() {
      return !!Object.keys(this.result?.collections)?.length;
    },
    isShowSections() {
      return !!this.getSections?.length;
    },
    sectionsTitle() {
      return this.result?.messages?.sectionsTitle;
    },
    collectionsTitle() {
      return this.result?.messages?.collectionsTitle;
    },
    itemsTitle() {
      return this.result?.messages?.itemsTitle;
    },
  },
  methods: {
    getId(item) {
      return item?.offer?.id ?? item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-engine-top-response {
  @include point-md {
    display: flex;
    align-items: flex-start;
  }
  &__title {
    font-size: rem(12);
    margin-bottom: 12px;
    font-weight: rem(500);
    line-height: 120%;
    color: #5f5f67;
  }
  &__block {
    display: flex;
    flex-direction: column;
    margin-bottom: 4px;
  }
  &__sections {
    display: flex;
    flex-direction: column;
  }
  &__section {
    font-size: rem(16);
    line-height: 125%;
    font-weight: 500;
    margin-bottom: 15px;
  }
  &__products {
    display: grid;
    grid-row-gap: 4px;
  }
  :deep(.search-suggests) {
    @include point-md {
      margin-right: 24px;
    }
  }
}
.search-engine-top-response-main {
  flex-grow: 1;
}
</style>
